
<template>

	<div id="main">
		<!--
		<SpecialStream headerClasses="introText pb-0 pt-2" :showSubHeader="false" :showProgrammLinks="false"/>
		-->

		<!-- Stream View -->
		<!--<RTStreamProgram class="pt-0 border-top-none"/>-->

		<!-- Staffel 1 -->
		<RTProgram provider="weltsichten" />

		<!-- Descr hinzufügen und max 3 unten anzeigen oder height dynamisch erhöhen-->

		<!-- TODO: Anzahl freier Plätze einblenden -->
		<!-- TODO: Countdown, wann vorverkauf anfängt -->
		<!-- TODO: in RTProgram: wenn provider angegeben, dann buchen button einblenden-->
		<!-- TODO: Startseite: staffel 2 datum einpflegen -->
		<!-- TODO ANzahl streams im header: nur ohne provider? --> 
		<!-- Code einblenden + per mail senden, wenn bezahlt -->

	</div>
</template>

<script>

import RTProgram from '@/components/RTProgram.vue'
//import SpecialStream from '@/components/SpecialStream.vue'
//import RTStreamProgram from '@/components/RTStreamProgram.vue'
//import RTProgramEmptyDefault from '@/components/RTProgramEmptyDefault.vue'

import CONFIG from '@/constants/config.js';
import {categoryBase} from '@/mixins/categoryBase.js'
import {shopBase} from '@/mixins/shopBase.js'
import {helper} from '@/mixins/helper.js'
import {projectBase} from '@/mixins/projectBase.js'

export default {
	name: 'StreamsView',
	mixins:[helper,categoryBase,shopBase,projectBase],
	components: {
		RTProgram,
		//SpecialStream
	},
	data(){
		return{
			tab:1,
			visible:false,
			search:"",
			searchCategoryId:0,
			searchShippingId:0,
			searchTopCategoryId:0,
			busy: false,
			theme:1,
			isTouchDevice:false,
			clickedShop:null,
			gridView:true,
			scrollposition:0,
			touchedCardId:null,
			blockedSearch:true
		}
	},
	watch:{
		
	},
	computed:{

		showLandingPage(){
			return CONFIG.SHOW_LANDING_PAGE;
		},
		data(){
			return this.$store.state.shops.allPaged
		},
		isLoading(){
			return this.$store.state.shops.isLoading;
		},

		maxEntriesReached(){
			return (this.data && this.dataset)?(this.data.length>=this.dataset.length):true;
		},

		companiesCount(){
			return (this.dataset && this.dataset.length>0)?this.dataset.length:'';
		},

        subtitle(){
            return `Kauf direkt und ohne Umwege von ${this.companiesCount} lokalen Unternehmen`;
        },

		hasSearchCategory(){
			return (this.searchCategoryId>0);
		},
		hasSearchShipping(){
			return (this.searchShippingId>0);
		},
		hasSearchTopCategory(){
			return (this.searchTopCategoryId>0);
		},
		hasSearchString(){
			return (this.search && this.search.trim()!="");
		},
		hasFilter(){
			return this.hasSearchTopCategory || this.hasSearchCategory || this.hasSearchString || this.hasSearchShipping;
		},
		seachedShops(){
			let res=this.dataset;

			if(this.hasSearchCategory){
				res= this._.filter(res,(shop)=>{
					return this.compareWithCategories(shop.category,this.searchCategoryId);
				});
			}
			
			if(this.hasSearchString){
				res= this._.filter(res,(shop)=>{
					return (this.compareWithSearch(this.getCategoriesAsString(shop.category)) || this.compareWithSearch(shop.title) || this.compareWithSearch(shop.company)|| this.compareWithSearch(shop.descr)|| this.compareWithSearch(shop.name,true)|| this.compareWithSearch(shop.nr,true));
				});
			}

			if(this.hasSearchTopCategory){
				res= this._.filter(res,(shop)=>{
					return this.compareWithCategories(shop.top_cat,this.searchTopCategoryId);
				});
			}

			if(this.hasSearchShipping){
				res= this._.filter(res,(shop)=>{
					return this.compareWithShippings(shop.ship,this.searchShippingId);
				});
			}

			return res;
		}
	},
	methods:{
		onTabChanged(tab){
			this.tab=tab;
		},
		setTopCategory(topCat){
			if(topCat>0){
				this.resetSearchParams();
				this.searchTopCategoryId=topCat;
			}
		},

		resetSearchParams(){
			this.search="";
			this.searchCategoryId=0;
			this.searchShippingId=0;
		},
		onCardTouched(shop){
			if(shop){
				this.touchedCardId=shop.id;
			}
		},

		showPressModal() {
			this.$refs.pressModal.show();
		},

		compareWithCategories(catIds,searchCatId){
			return this.compareIdWithIds(catIds,parseInt(searchCatId))
		},
		compareWithShippings(shipIds,seachShipId){
			return this.compareIdWithIds(shipIds,parseInt(seachShipId))
		},

		getShopsWithCategoryCount(catId,dataset){
			return this.getShopsWithAttrCount(catId,dataset,'category');
		},

		getShopsWithTopCategoryCount(catId,dataset){
			return this.getShopsWithAttrCount(catId,dataset,'top_cat');
		},

		loadMore() {
			this.busy = true;
			this.$store.dispatch('shops/getNextPagedShops');
			this.busy = false;
		},
		compareWithSearch(str){

			//let s1=(removeEmptySpaces)?replaced = str.split(' ').join('+');
			return (this._.isString(str))? str.toLowerCase().trim().includes(this.search.toLowerCase().trim()):false;
		},

		getStyleArticle(){
			return {
				'opacity':1
			}
		},

		detectTouchDevice(){
			this.isTouchDevice=this.isMobileTouchDevice();
		},

		setTopCategoryOfShopByCategories(shop){
			if(shop){

				//jede category im shop durchgehen
				// category finden und top:_cat in extra array
				//unique cat array zurückgeben
				let res=[];
				if(shop.category){
					this._.forEach(shop.category,(catId)=>{
						let cat=this.getCategoryById(catId);
						if(cat){
							res=res.concat(cat.top_cat);
						}
					});
				}

				if(res.length>0){
					shop.top_cat=this._.uniq(res);
				}
			}
			return shop;
		},
	},
	
	activated() {
		//window.scrollTo(0, this.scrollposition);
	},
	beforeRouteLeave(to, from, next) {
		console.log('beforeRouteLeave');
		this.scrollposition = window.scrollY;
		next();
	},
	/*
	beforeRouteEnter: (to,from,next) => {
		next(vm => {
			setTimeout(()=>{
				window.scrollTo(0, vm.scrollposition);
			},300);
		});
	},
	*/

	mounted(){
		console.log('mounted');
		this.detectTouchDevice();
	}
}
</script>

<style scoped>

.flexbox {
  flex-wrap: wrap;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
	align-items: stretch;
	justify-content: center;
}

.noBoarder{
    border-bottom: none;
}
	
</style>
